export enum ServiceLogComeFrom {
  /** 前台問題 */
  Q = 'Q',
  /** 後台回覆 */
  A = 'A',
  /** 後台轉發 */
  M = 'M'
}
